import { useNavigate } from "react-router-dom";
import { ReviewQueueView } from "@/features/admin/review-queue/components/ReviewQueueView";

export function ReviewQueuePage() {
  const navigate = useNavigate();
  return <ReviewQueueView onViewItem={(id) => navigate(`/admin/review-queue/${encodeURIComponent(id)}`)} />;
}
